module.exports = __webpack_public_path__ + "0c15a408add25a1adade197c789ec049.MP3";